<template>
    <div class="invite-share-bottom">
        <div class="btn-share" @click="showShare">
            <img src="../../../../assets/images/parent_active/invite/ic_invite_gold.png"/>
        </div>
    </div>
</template>

<script>
import inviteShare from './invite-share';
import { graduallyShow } from '@/utils/graduallyShow';

export default {
    components: { inviteShare },

    props: ['shareUrl', 'shareTitle', 'shareDesc','show'],

    methods: {
        showShare() {
            console.log('vtap')
            this.$emit('handleBottomShare');
            this.$emit('update:show', true);
        },
        close() {
            this.$emit('update:show', false);
        },
        handleClose(e) {
            if (e.target.classList.contains('share-wrap')) {
                this.close();
            }
        },
    },

    mounted() {
        // 吸地按钮滚动显示效果
        const monitorDOM = document.querySelector('.invite-share');
        if (monitorDOM) {
            graduallyShow(
                document.querySelector('.wrap'),
                monitorDOM,
                document.querySelector('.btn-share')
            );
        }
    }
};
</script>

<style lang="sass" scoped>
.invite-share-bottom
    .share-wrap
        width: 100%
        height: 100%
        position: absolute
        left: 0
        top: 0
        background-color: rgba(0,0,0,0.7)
        z-index: 10
    .btn-share
        width: 100%
        height: 1rem
        background: linear-gradient(90deg, #E84242, #F0A548);
        text-align: center
        line-height: 1rem
        color: #ffffff
        position: absolute
        left: 0
        bottom: 0
        font-family: PingFangSC-Medium
        font-size: 0.36rem
        img
            width: 2.98rem
            height: 0.43rem
            margin-top: 0.3rem
</style>
